export enum LookupEnum {
  MainPurposeOfFundUtilization = 1,
  OfferIssuerRaiseFunds = 2,
  PercentageFundsRaiseBefore = 3,
  FundsPreviouslyOfferIssuer = 4,
  CompanyShariaaCompilant = 5,
  Sectors = 6,
  OpportunityCategories = 7,
  Ownershipstructure = 8,
  TermsOfAgreementChangesList = 9,
  InvestorsNumberRestriction = 10,
  IslamicShariaCompliance = 11,
  Status = 12,
  IncorporationJurisdiction = 13,
  LegalStructureofTheOfferIssuer = 14,
  ConcurrentlyIssuingOtherOffering = 15,
  PreviouslyIssuingOtherOfferings = 16,
  OfferIssuerHaveRelationShip = 17,
  OfferIssuerPay = 18,
  ExistingDividendOrDistributionPolicyList = 19,
  PreventingDividendPolicy = 20,
  PreventingPayingDividend = 21,
  LegalProceedings = 22,
  PreferenceCommunication = 23,
  AICClient = 24,
  Gender = 25,
  Designations = 26,
  MonthlyIncomme = 27,
  AverageAnnualIncome = 28,
  EstimatedWealth = 29,
  InvestmentObjective = 30,
  RiskTolerance = 31,
  PreferredProducts = 32,
  BeneficiaryRelationship = 33,
  PoliticallyExposedPersonPositions = 34,
  OfferIssuerRaiseFundsAnotherPlatform = 36,
}
export enum RaiseFundsAnotherPlatform {
  Yes = 1,
  No = 2,
}

export enum OfferIssuerValues {
  Yes = 1,
  No = 2,
}

export enum SectorValues {
  RealEstate = 11,
  Equity = 12,
}

export enum ShariaCompliantValues {
  Yes = 9,
  No = 10,
}

export enum AichasRelations {
  Yes = 55,
  No = 56,
}

export enum ConcurrentlyIssuingOtherOffering {
  Yes = 51,
  No = 52,
}

export enum AICClient {
  Yes = 77,
  No = 78,
}

export enum Users {
  Admin=2
}

export enum InvestorStatus {
  Draft = 113,
  PendingApproval = 114,
  Active = 115,
  Inactive = 116,
}

export enum PreviouslyIssuingOtherOffering {
  Yes = 53,
  No = 54,
}

export enum Restrictions {
  Yes = 68,
  No = 69,
}

export enum InvestmentObjective {
  Other = 98,
}

export enum PreferredProducts {
  Other = 105,
}

export enum LegalStructureofTheOfferIssuer {
  Others = 50,
}

export enum LegalProceedings {
  Yes = 71,
  No = 72,
}

export enum StatusValues {
  Draft = 123,
  Active = 26,
  Cancelled = 28,
  Closed = 29,
}
export enum FileTypes {
  Cover = 1,
  Image = 2,
  Video = 3,
  AuditorReports = 4,
  FinPositionStatement = 5,
  IncomeStatement = 6,
  EquityChangesStatement = 7,
  CashFlowStatement = 8,
  FinancialNotesStatement = 9,
  LegalStructureDocument = 10,
  AssociationArticlesDocuments = 11,
  MociregistrationDocument = 12,
  CivilIdDocument = 13,
  PassportDocument = 14,
  RealEstateEvaluationDocument = 15,
}

export enum Countries {
  KuwaitId = 1,
}

export enum JurisdictionOfIncorporationCountries {
  KuwaitId = 30,
}
